/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function(_) {
  var ns;

  ns = window.nspace("ccc.shared");

  /**
   *
   */
  ns.ArraySerializationRouterBase = Backbone.Router.extend({
    initialize: function() {
      throw "initialize should be overridden in sub classes.";
    },

    /**
     * Deserializes a string property to an array.
     */
    getArrayFromModelProperty: function(value) {
      // Ignore falsy values.
      if (!value) {
        return [];
      }

      // Ignore non-string values.
      if (typeof value !== "string") {
        return [];
      }

      // n designates none, or an empty set.
      if (value === "n") {
        return [];
      }

      return value.split(",");
    },

    /**
     * Serializes an array to a string for display in the route.
     */
    getStringFromArrayProperty: function(array) {
      // Empty arrays get "n".
      if (!array.length) {
        return "n";
      }

      return array.join(",");
    }
  });
})(_);
